import {
  searchBankDetailsActions,
  searchBranchDetailsActions,
} from "./BankDetailsDropdownAction";

const initialState = {
  searchBankDetails: [],
  bankLoading: false,
  searchBankError: "",
  searchBranchDetails: [],
  branchLoading: false,
  searchBranchError: "",
};

const BankDetailsDropdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case searchBankDetailsActions.SEARCH_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        searchBankDetails: action.payload,
        bankLoading: false,
      };
    case searchBankDetailsActions.SEARCH_BANK_DETAILS_ERROR:
      return {
        ...state,
        searchBankError: action.payload,
        bankLoading: false,
      };
    case searchBankDetailsActions.SEARCH_BANK_DETAILS_LOADING:
      return {
        ...state,
        bankLoading: true,
      };
    case searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_SUCCESS:
      return {
        ...state,
        searchBranchDetails: action.payload,
        branchLoading: false,
      };
    case searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_ERROR:
      return {
        ...state,
        searchBranchError: action.payload,
        branchLoading: false,
      };
    case searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_LOADING:
      return {
        ...state,
        branchLoading: true,
      };
    default:
      return state;
  }
};

export default BankDetailsDropdownReducer;
